var initObj = {
  footprint: 'all',
};

export function lsTimelineConditionInit() {
  localStorage.setItem('TimelineCondition', JSON.stringify(initObj));
}
